/**
 * Created by Owner on 2016/8/8.
 */
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {LotteryService} from "../../services/lottery.services";
import {AppConfigService} from "../../services/appConfig.service";
import {AlertController, App, LoadingController} from "ionic-angular";
import {AppDialog} from "../appDialog";
import {SixMarkService} from "../../services/sixmark.services";
import {LotteryPage} from "../../pages/lottery/lottery";
import * as common from '../../directives/common';
import {TaixiuServices} from "../../services/taixiu.services";
import { TranslateService } from 'ng2-translate';



@Component({
    selector: 'drop-select-panel',
    templateUrl: 'dropSelectPanel.html',
    // providers: [LotteryService, AppConfigService]
})
export class DropSelectPanel implements OnInit {
    @Input() lotteryFaces: any;
    @Input() lotteryType: any;
    @Input() lotteryId: number;
    @Input() dropPanelShow: boolean;
    @Output() onActiveLottery: EventEmitter<any> = new EventEmitter<any>();
    @Output() onHidden: EventEmitter<boolean> = new EventEmitter<boolean>();
    //初始化加载完毕
    @Output() onInitAfter: EventEmitter<any> = new EventEmitter<any>();

    public userPrizeCurrent:any;
    private planeTitle: string;
    //选中主玩法
    private lotteryActiveParent;
    private lotteryGameTitle: string;
    private lotteryActiveIndex: number = 0;
    private initParams: any = {};

    public flagTaiXiu: boolean = false;
    public descTaiXiu: string = '';

    /**
     * 玩法的位置
     * @type {{group: number;玩法组 index: number 玩法}}
     */
    private lotteryActiveGameIndex = {
        group: 0,
        index: 0
    };

    constructor(private alertCtrl: AlertController, public loadingCtrl: LoadingController, private lotteryService: LotteryService,
                private sixMarkService: SixMarkService, private taixiuService: TaixiuServices, private app: App,
                private translate: TranslateService) {}

    ngOnInit() {
        console.log('====================================');
        console.log('this.lotteryFaces',this.lotteryFaces);
        console.log('====================================');
        this.lotteryFaces = JSON.parse(JSON.stringify(this.lotteryFaces));
        if ( common.checkGameTaiXiu(this.lotteryId) ) { // game tai xiu
            this.flagTaiXiu = true;
            this.taixiuInit();
        }else {
            this.flagTaiXiu = false;
            this.lotteryInit();
        }
    }

    taixiuInit() {
        let selectIndex: number = 0;
        this.lotteryFaces.map(function (item, index) {
            if (item["isdefault"] == true) {
                selectIndex = index;
            }
            return item;
        });
        if (Number(this.lotteryId) === 60) { // is 1giay
            let params = {
                lotteryId: this.lotteryId
            };
            this.taixiuService.diceInit(params, this).then(data => {
                if (data) {
                    this.initParams["chips"] = eval(data['chips']);
                    this.initParams["history"] = eval(data['history']);
                    this.initParams["lotteryid"] = this.lotteryId;
                    this.onInitAfter.emit(this.initParams);
                    this.selectLotteryActive(selectIndex);
                }
            }).catch(error => {
                console.log(error);
            });
        }else { // is 1phut
            this.taixiuService.mDiceInit([], this).then(data => {
                if (data['status'] === 'error') {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: this.translate.instant('TAIXIU.ERROR_GET_DATA'),
                        callBack: () => {
                            let tabsRoot = this.app.getRootNav();
                            tabsRoot.pop();
                        }
                    });
                }else {
                    this.initParams["chips"] = data['data']['chips'];
                    this.initParams["history"] = data['data']['history'];
                    this.initParams["opentime"] = data['data']["cursitem"]["opentime"];
                    this.initParams["endtime"] = data['data']["cursitem"]["endtime"];
                    this.initParams["issue"] = data['data']["cursitem"]["issue"];
                    this.initParams["servertime"] = data['data']["servertime"];
                    this.initParams["lotteryid"] = this.lotteryId;
                    this.onInitAfter.emit(this.initParams);
                    this.selectLotteryActive(selectIndex);
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    /**
     * showMessage()
     *
     */
    showMessage(message) {
        AppDialog.alert({
            alertCtrl: this.alertCtrl,
            message: this.translate.instant(message)
        });
    }

    /**
     * lotterySixMarkInit()
     * Init of sixmark game type
     */
    lotterySixMarkInit() {
        let lotteryId: number;
        if (this.lotteryType == "fenfenliuhe") {
            lotteryId = 82; // 分分六合彩
        } else if (this.lotteryType == "liuhe") {
            lotteryId = 81; // 六合彩
        }
        let dataParams = {
            lotteryid: lotteryId
        };
        let selectIndex: number = 0;
        this.sixMarkService.sixMarkInit(dataParams, this.alertCtrl).then(response => {
            if (response["status"] == "success") {
                let data = response["data"];
                this.initParams["lotteryid"] = data["lotteryid"];
                this.initParams["userbalance"] = parseFloat(data["userbalance"]);
                this.initParams["lotteryName"] = data["lotteryname"];
                this.initParams["endtime"] = data["curissue"]["endtime"];
                this.initParams["issue"] = data["curissue"]["issue"];
                this.initParams["servertime"] = data["servertime"];
                this.initParams["issueliststr"] = data["issueliststr"];
                //this.initParams["bonusgroup"] = data["bonusgroup"];
                //this.initParams["bonusgroups"] = data["bonusgroups"];
                //this.initParams["maxbonusmoney"] = data["maxbonusmoney"];
                this.initParams["marksixmethod"] = data["marksixmethod"];
                this.onInitAfter.emit(this.initParams);
                this.selectLotteryActive(selectIndex);
            } else {
                this.showMessage(response["data"]["data"]);
            }
        });
    }

    /**
     * lotteryInit()
     * Init of normal game type
     */
    lotteryInit() {
        if(this.lotteryType == 'MB'){
            this.lotteryType = 'VN';
        }
        if(this.lotteryType == 'MBDB'){
            this.lotteryType = 'VN';
        }
        let dataParams = {
            flag: this.lotteryType,
            lotteryId: this.lotteryId
        };

        let selectIndex: number = 0;
        console.log('dataParams dropselect',dataParams);
        
        this.lotteryService.lotteryInit(dataParams, this).then(data => {
            if (!data["msg"]) {

                // console.log('data dropselect', data);
                
                let userPrize: any = JSON.parse(data["userprize"]);
                this.userPrizeCurrent = userPrize;
                let userPrizeObject: any = {};
                userPrize.forEach(function (item) {
                    userPrizeObject[item["methodid"]] = item;
                });
                
                this.lotteryFaces.map(function (item, index) {
                    if (item["isdefault"] == true) {
                        selectIndex = index;
                    }
                    item["label"].map(function (labelItem) {
                        labelItem["label"] = labelItem["label"].filter(function (labelClItem) {
                            if (userPrizeObject[labelClItem["methodid"]]) {
                                let userPrizeItem = userPrizeObject[labelClItem["methodid"]];
                                labelClItem["methodidInDB"] = userPrizeItem["methodidInDB"];
                                labelClItem["prize"] = userPrizeItem["prize"];
                                labelClItem["dyprize"] = userPrizeItem["dyprize"];
                                labelClItem["payprizenum"] = userPrizeItem["payprizenum"];
                                return labelClItem;
                            }
                        });
                        return labelItem;
                    });
                    return item;
                });


                this.initParams["lotteryid"] = data["lotteryid"];
                this.initParams["lotteryName"] = data["lotteryname"];
                this.initParams["opentime"] = data["cursitem"]["opentime"];
                this.initParams["endtime"] = data["cursitem"]["endtime"];
                this.initParams["issue"] = data["cursitem"]["issue"];
                this.initParams["servertime"] = data["servertime"];
                this.initParams["userPrize"] = data["userPrize"];

                
                this.onInitAfter.emit(this.initParams);
                this.selectLotteryActive(selectIndex);
            } else {
                this.showMessage(data["msg"]);
            }
        });
    }

    /**
     * 选择大组
     * @param index
     */
    selectLotteryActive(index: number = 0) {
        this.lotteryFaces[this.lotteryActiveIndex].isdefault = false;
        this.lotteryActiveParent = this.lotteryFaces[this.lotteryActiveIndex].label;
        if (!common.checkGameTaiXiu(this.lotteryId)) {
            this.lotteryActiveParent[this.lotteryActiveGameIndex.group].label[this.lotteryActiveGameIndex.index]["isSelect"] = false;
            console.log('this.lotteryActiveParent',this.lotteryActiveParent);
            
        }else {
            this.descTaiXiu = this.lotteryFaces[index].label[0].description;
        }
        //初始化新的大类玩法
        this.lotteryActiveIndex = index;
        this.lotteryActiveParent = this.lotteryFaces[this.lotteryActiveIndex].label;
        this.lotteryGameTitle = this.lotteryFaces[this.lotteryActiveIndex].title;
        this.lotteryFaces[index].isdefault = true;
        this.selectLotteryGame();
    }

    /**
     * 选择玩法
     * @param newGroup
     * @param newIndex
     * @param close 关闭面板
     */
    selectLotteryGame(newGroup: number = 0, newIndex: number = 0, close: boolean = false) {
        if (common.checkGameTaiXiu(this.lotteryId)) {
            this.planeTitle = this.lotteryGameTitle;

            this.onActiveLottery.emit({
                title: this.planeTitle,
                activeLottery: this.lotteryActiveParent[this.lotteryActiveGameIndex.group],
                userPrizeCurrent: this.userPrizeCurrent
            });
        }else {
            if (close) {
                this.lotteryActiveParent[this.lotteryActiveGameIndex.group].label[this.lotteryActiveGameIndex.index]["isSelect"] = false;
            }

            this.lotteryActiveGameIndex = {
                group: newGroup,
                index: newIndex
            };
            this.lotteryActiveParent[this.lotteryActiveGameIndex.group].label[this.lotteryActiveGameIndex.index]["isSelect"] = true;
            this.planeTitle = this.lotteryGameTitle + " - " +
                this.lotteryActiveParent[this.lotteryActiveGameIndex.group].label[this.lotteryActiveGameIndex.index]["name"];

            this.onActiveLottery.emit({
                title: this.planeTitle,
                activeLottery: this.lotteryActiveParent[this.lotteryActiveGameIndex.group].label[this.lotteryActiveGameIndex.index],
                userPrizeCurrent: this.userPrizeCurrent
            });
        }
        if (close) {
            this.hidePanel();
        }
    }

    //关闭面板
    hidePanel() {
        this.dropPanelShow = false;
        this.onHidden.emit(false);
    }
}



// WEBPACK FOOTER //
// ./src/component/dropSelectPanel/dropSelectPanel.ts